import * as Sentry from '@sentry/nuxt'

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,

    // Release and environment information
    release: process.env.SENTRY_RELEASE_NAME || process.env.SENTRY_RELEASE,
    environment: process.env.SENTRY_DEPLOY_ENVIRONMENT || process.env.NODE_ENV,

    // Adjust sampling rates for production
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

    // This sets the sample rate to be 10% in production and 100% in development
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Enable session replay for better error understanding
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration()
    ],

    // Enable debug mode in development
    debug: process.env.NODE_ENV !== 'production'
  })

  // Set release author after initialization
  if (process.env.SENTRY_RELEASE_AUTHOR) {
    Sentry.setTag('release.author', process.env.SENTRY_RELEASE_AUTHOR)
  }
}
